import { Modal, Select, Input, Radio, Button} from 'antd';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';
import './Teams.css';
import HierarchicalDropdown from '../Roles/HierarchicalDropdown';
import AwsServerService from '../../common/util/AwsServerService';
const { Option } = Select;

export default function ({openTeamsModal,onCancel,reloadTeams}) {
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const [data,setData] = useState([]); 
  const [teamData, setTeamData] = useState({
      name: '',
      participants: [],
    //   privilege: 'view',
  });
  useEffect(()=>{
    if(openTeamsModal?.open && openTeamsModal?.type=='edit'){
        let data= {...openTeamsModal?.data};
        setTeamData({name:data?.Team_Name,participants:data?.Members,ROWID:data?.ROWID});
    }else{
        setTeamData({name:'',participants:[]});
    }
  },[openTeamsModal?.open])
    console.log("teams",teamData);
    
  const handleChange = (field, value) => { 
    setTeamData(prev => ({
        ...prev,
        [field]: value,
    }));
    };
  const handleSubmit = () => {
    if (!teamData.name) {
        alert("Team name is required!");
        return;
    }
    if (teamData.participants.length < 2) {
        alert("At least two participants must be selected.");
        return;
    }
    if(openTeamsModal?.type=='create'){
    const payload = {
            Team_Name:teamData.name,
            Members:JSON.stringify(teamData.participants),
            CREATEDBY:userinfo?.zuid  
        }
        AwsServerService.CrudServiceHandler({method:'POST',data:payload,route:'TEAMS'}).then(res=>{
            reloadTeams();
            setTeamData({name: '',participants: []})
            onCancel();
        })
    }else{
        const payload = {
            ROWID:teamData.ROWID,
            Team_Name:teamData.name,
            MODIFIEDBY:userinfo?.zuid,
            Members:JSON.stringify(teamData.participants) 
        }
        AwsServerService.CrudServiceHandler({method:'PUT',data:payload,route:'TEAMS'}).then(res=>{
            reloadTeams();
            setTeamData({name: '',participants: []})
            onCancel();
        })
    }
  }
  return (
    <div>
        <Modal 
           rootClassName='Teams-modal'
           destroyOnClose={true}
           title={openTeamsModal?.type == "edit" ? "Edit Team" : "Create New Team"}
           onCancel={onCancel}
           open={openTeamsModal?.open}
           maskClosable={false}
           footer={[
            <Button type='default' onClick={onCancel}>Cancel</Button>,
            <Button type='default' onClick={()=>handleSubmit()}>{openTeamsModal?.type=='create'?'Create':'Edit'}</Button>
           ]}
        >
            <div className='CreateTeamContainer'>
       <Row style={{ marginBottom: 20 }} className="align-items-center">
                <Col sm={2}>
                    <label>Name :</label>
                </Col>
                <Col sm={10}> 
                <Input
                    placeholder="Enter team name..."
                    value={teamData.name}
                    onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart().replace(/[^a-zA-Z0-9 ]/g, '');                        ;
                        handleChange('name', e.currentTarget.value)}}
                />
                </Col>
            </Row> 
            <Row className="align-items-center">
                <Col sm={2} style={{width:"max-content"}}>
                    <label style={{width:'max-content'}}>Participants :</label>
                </Col>
                <Col sm={10}>
                <HierarchicalDropdown 
                GroupName={["Role","Zoho"]} 
                handleChangeUser={(value)=>handleChange('participants', value)}
                selectedUsers={teamData.participants}
                placeholder={"Select Assignee"}
                isMulti={true} 
                styles={{width:'100%',height:'auto'}} /> 
                </Col>
                </Row> 
            </div>
        </Modal>
    </div>
  )
}
